import { render, staticRenderFns } from "./StatementAccount.vue?vue&type=template&id=1c0f2484&scoped=true"
import script from "./StatementAccount.vue?vue&type=script&lang=js"
export * from "./StatementAccount.vue?vue&type=script&lang=js"
import style0 from "./StatementAccount.vue?vue&type=style&index=0&id=1c0f2484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0f2484",
  null
  
)

export default component.exports